import { createFileRoute } from '@tanstack/react-router';

import { AiModelsPage } from '@/features/ai-models/components/AiModelsPage';
import { aiModelsSearchSchema } from '@/features/ai-models/aiModelsSearch';

export const Route = createFileRoute(
  '/workspaces/$workspaceId/ai-usage/models',
)({
  // The period lives in the address, as on the Usage page, so a link that works on one
  // works on the other (spec 215 FR-007); the view beside it (spec 221).
  validateSearch: aiModelsSearchSchema,
  component: AiModelsRoute,
});

export function AiModelsRoute() {
  const { workspaceId } = Route.useParams();
  const { period, view } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <AiModelsPage
      workspaceId={workspaceId}
      period={period}
      view={view ?? 'profile'}
      onPeriodChange={(next) => {
        // `replace`, as Usage does, so stepping through months leaves no trail in the
        // back button.
        void navigate({
          search: (prev) => ({ ...prev, period: next }),
          replace: true,
        });
      }}
      onViewChange={(next) => {
        void navigate({
          search: (prev) => ({
            ...prev,
            view: next === 'workflow' ? 'workflow' : undefined,
          }),
          replace: true,
        });
      }}
    />
  );
}
